import { render, staticRenderFns } from "./VideosByCategory.vue?vue&type=template&id=1eaeae17"
import script from "./VideosByCategory.vue?vue&type=script&lang=js"
export * from "./VideosByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports